/* eslint-disable import/prefer-default-export */

export const selectCourseCohorts = state => state.cohorts.cohorts;
